// extracted by mini-css-extract-plugin
export default {"products":"Cv-z","card":"Dv-z","oosMessaging":"Ev-z"};